import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_one } from "../../lib/v31lib";
import { loginAtom } from '../../lib/auth';
// import { currentPracticeAtom } from '../../lib/practice';


// import {
//   Box,
//   Grid,
//   MenuItem,
// } from '@mui/material';

import {
  Typography
} from '../../components/v2/styled';
import { MenuDesktop } from './menu/Desktop';
import { MenuMobile } from './menu/Mobile';
import { MenuTablet } from './menu/Tablet';
import { MenuDesktopInternal } from './menu/DesktopInternal';
import { MenuTabletInternal } from './menu/TabletInternal';
import { MenuMobileInternal } from './menu/MobileInternal';
import { useMutation } from '@tanstack/react-query';

// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  drawerOpen?: boolean;
  setDrawerOpen?: (b:boolean) => void;
}

export const SharedHeader: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const location = useLocation();

  const [scrolled, setScrolled] = useState<boolean>(false);
  const [showAlternate, setShowAlternate] = useState<boolean>(false);

  // const {
  //   data: usr,
  //   // isLoading: adviceUploadsLoading,
  //   // isError: adviceUploadsError,
  //   // isSuccess: adviceUploadsSuccess,
  //   // refetch: adviceUploadsRefetch,
  // } = useQuery({
  //   queryKey: ["full_user", login?.id],
  //   queryFn: () =>
  //     fetch_one<User>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
  //       {
  //         object: 'user',
  //         fields: [...loginFields, 'last_diary_entry'],
  //         id: login?.id,
  //         ob: {
  //           id: login?.id
  //         }
  //       },
  //       login
  //     ),
  //   enabled: !!login,
  // });

  





  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log("saved_language");
    },
  });

  const LanguagePicker = (b:boolean, white?:boolean) => {
    return (<>
      <Typography sx={{
        cursor: 'pointer',
        fontSize: '14px',
        display: 'inline-block',
        textDecoration: (i18n.resolvedLanguage !== 'nl' ? 'underline' : undefined),
        color: theme.palette.primary.main,
        ...(!!white ? {
          color: 'white'
        } : {})
      }} onClick={() => {
        if (!!login?.id) {
          mutationCustomAction.mutate({
            formData: {
              object: 'user',
              class_action: 'custom_api_update_locale',
              new_locale: 'nl',
              id: login?.id
            }
          });
        }
        i18n.changeLanguage('nl');
      }}>Nederlands</Typography> - <Typography sx={{
        cursor: 'pointer',
        fontSize: '14px',
        display: 'inline-block',
        textDecoration: (i18n.resolvedLanguage !== 'fr' ? 'underline' : undefined),
        // color: ((scrolled || b) ? theme.palette.primary.main : 'white'),
        color: theme.palette.primary.main,
        ...(!!white ? {
          color: 'white'
        } : {})
      }} onClick={() => {
        if (!!login?.id) {
          mutationCustomAction.mutate({
            formData: {
              object: 'user',
              class_action: 'custom_api_update_locale',
              new_locale: 'fr',
              id: login?.id
            }
          });
        }
        i18n.changeLanguage('fr');
      }}>Français</Typography>
    </>);
  }

  useEffect(() => {
    const scrollFun = () => {
      // @ts-ignore
      if (window.scrollY < 1) {
        setScrolled(false);
      } else {
        setScrolled(true);
      }
    }
    
    // @ts-ignore
    window.addEventListener("scroll", scrollFun);
  
    return () => {
      // @ts-ignore
      window.removeEventListener("scroll", scrollFun);
    };
  }, []);

  useEffect(() => {
    let exception = false;
    if (location.pathname.indexOf("/profile") > -1) exception = true;
    if (location.pathname.indexOf("/edit_profile") > -1) exception = true;
    if (location.pathname.indexOf("/my_documents") > -1) exception = true;
    if (location.pathname.indexOf("/my_transactions") > -1) exception = true;

    setShowAlternate(exception);
  }, [location.pathname]);

  return <>
    {!showAlternate && <>
      <MenuDesktop
        LanguagePicker={LanguagePicker}
        scrolled={scrolled}
      />
      <MenuTablet
        LanguagePicker={LanguagePicker}
        scrolled={scrolled}
      />
      <MenuMobile
        LanguagePicker={LanguagePicker}
        scrolled={scrolled}
      />
    </>}
    {!!showAlternate && <>
      <MenuDesktopInternal
        LanguagePicker={LanguagePicker}
        scrolled={scrolled}
      />
      <MenuTabletInternal
        LanguagePicker={LanguagePicker}
        scrolled={scrolled}
      />
      <MenuMobileInternal
        LanguagePicker={LanguagePicker}
        scrolled={scrolled}
      />
    </>}
  </>;
}

